import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'water_sources'

export const dataPointDefinition = {
  retracedId: 'water_sources',
  name: 'What are your water sources and how much was consumed?',
  meta: {
    isMultipleRow: true,
    columns: [
      {
        key: 1,
        name: 'Water Sources',
        type: 'SELECT',
        id: 'water_sources',
        options: [
          {
            key: 'FRESH_SURFACE_WATER',
            text: 'Fresh Surface Water',
          },
          {
            key: 'GROUNDWATER',
            text: 'Groundwater',
          },
          {
            key: 'MUNICIPAL_WATER',
            text: 'Municipal Water',
          },
          {
            key: 'PRODUCED_OR_PROCESSED_WATER',
            text: 'Produced or processed steam water',
          },
          {
            key: 'RAINWATER',
            text: 'Rainwater',
          },
          {
            key: 'SEAWATER',
            text: 'Seawater',
          },
          {
            key: 'UNKNOWN_ORIGIN',
            text: 'Unknown Origin',
          },
          {
            key: 'WATER_SOURCES_FROM_ANOTHER_ORGANIZATION',
            text: 'Water sources from another organization',
          },
        ],
      },
      {
        key: 2,
        name: 'Total Annual Consumption',
        type: 'NUMBER_UOM',
        unit: 'CUBIC_METRE',
        unitText: 'm³',
        id: 'total_annual_consumption',
      },
      {
        key: 3,
        name: 'Year',
        type: 'SELECT_YEAR',
        id: 'year',
      },
    ],
  },
  fieldTypeId: 'TABLE',
  type: 'RELATIONAL',
  options: [
    {
      waterSources: [
        {
          key: 'FRESH_SURFACE_WATER',
          text: 'Fresh Surface Water',
        },
        {
          key: 'GROUNDWATER',
          text: 'Groundwater',
        },
        {
          key: 'MUNICIPAL_WATER',
          text: 'Municipal Water',
        },
        {
          key: 'PRODUCED_OR_PROCESSED_WATER',
          text: 'Produced or processed steam water',
        },
        {
          key: 'RAINWATER',
          text: 'Rainwater',
        },
        {
          key: 'SEAWATER',
          text: 'Seawater',
        },
        {
          key: 'UNKNOWN_ORIGIN',
          text: 'Unknown Origin',
        },
        {
          key: 'WATER_SOURCES_FROM_ANOTHER_ORGANIZATION',
          text: 'Water sources from another organization',
        },
      ],
    },
    {
      unit: {
        key: 'CUBIC_METRE',
        name: 'Cubic metre',
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            waterSources: {
              type: 'string',
              enum: [
                'FRESH_SURFACE_WATER',
                'GROUNDWATER',
                'MUNICIPAL_WATER',
                'PRODUCED_OR_PROCESSED_WATER',
                'RAINWATER',
                'SEAWATER',
                'UNKNOWN_ORIGIN',
                'WATER_SOURCES_FROM_ANOTHER_ORGANIZATION',
              ],
            },
            unit: {
              type: 'string',
              enum: ['CUBIC_METRE'],
            },
            totalAnnualConsumption: {
              type: 'number',
            },
            year: {
              type: 'number',
              minimum: 1000,
              maximum: 9000,
            },
          },
          required: ['waterSources', 'unit', 'totalAnnualConsumption', 'year'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 590,
  sectionId: '2.1.3.1',
  impactArea: 'Water Management',
  impactAreaId: 'WATER_MANAGEMENT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
